/**
 * Прослушивание событий
 * @param event
 * @param el
 * @param callback
 */
function listener (event, el, callback) {
	if (!document) return;
	document.addEventListener(event, function (e) {
		let selectors = document.body.querySelectorAll(el),
			element = e.target,
			index = -1;

		while (element && ((index = Array.prototype.indexOf.call(selectors, element)) === -1)) {
			element = element.parentElement;
		}

		if (index > -1) {
			(function () {
				if (typeof callback === "function") {
					callback(element, e);
				}

				// Действия после выполнения события будут срабатывать, т.к. preventDefault закомментирован...
				//e.preventDefault();
			}).call(element, e);
		}
	});
}

/**
 * EVENTS
 * @type {{on: eventHandler.on}}
 * Как это работает?
 * Вызов функции: eventHandler.on('элемент который нужно тригернуть', 'как тригернуть элемент');
 */
const eventHandler = {
	on: function (element, event, detail = {}) {
		const eventSuccess = new CustomEvent(event, {
			bubbles: true,
			detail: detail
		});

		element.dispatchEvent(eventSuccess);
	}
}

export {listener, eventHandler}
